import { jsx as _jsx } from "react/jsx-runtime";
import { ListItem } from '@mui/material';
import { memo } from 'react';
import { ItemButton } from '../styled';
import { ROUTES } from '@/shared/constants/routes';
const InnerHelpOption = ({ onClose }) => (_jsx(ListItem, { disableGutters: true, children: _jsx(ItemButton, { component: 'a', href: ROUTES.contactUs.path, target: '_blank', onClick: onClose, children: "Help" }) }));
export const HelpOption = memo(InnerHelpOption);
